const focusableElements = [
    "a[href]",
    "area[href]",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"])'
];

const keyList = {
    tab: 9,
    escape: 27
};

const breakpoints = {
    xs: 320, // Smartphone
    sm: 600, // Tablets
    md: 900, // Tablets Landscape and small desktops
    lg: 1200, // Desktops
    xl: 1800 // Large Desktop
};

const detectIE = () => {
    const ua = window.navigator.userAgent;

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
}

document.addEventListener("DOMContentLoaded", function () {
    // Polyfills
    const objectFitImageEls = document.querySelectorAll("img.media-cover");
    const stickyElements = document.querySelectorAll('.sticky');
    objectFitImages(objectFitImageEls);
    new lazyloadPicturefillBackground();
    cssVars();
    Stickyfill.add(stickyElements);
});